/** Account 'access card' data — port of mobile/src/features/account/library-card-data.ts. */
import { HIGHLIGHTERS, Highlighter } from './paper';
import { Note } from '../types/notes';
import { parseTags } from './tags';

/** Up to two initials for the card's monogram: name first, then email, then "?". */
export function initials(name: string | null | undefined, email: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  if (words.length === 1) return words[0][0].toUpperCase();
  const e = (email ?? '').trim();
  return e ? e[0].toUpperCase() : '?';
}

/** The rubber stamp on the library card: what the subscription looks like at a glance. */
export function stampFor({
  isSubscribed,
  cancelAtPeriodEnd,
}: {
  isSubscribed: boolean;
  cancelAtPeriodEnd: boolean;
}): { label: string; tone: Highlighter } {
  if (!isSubscribed) return { label: 'Inactive', tone: HIGHLIGHTERS.coral };
  if (cancelAtPeriodEnd) return { label: 'Ending', tone: HIGHLIGHTERS.yellow };
  return { label: 'Active', tone: HIGHLIGHTERS.mint };
}

export interface LibraryStats {
  pages: number | null;
  notebooks: number | null;
  tags: number | null;
}

/** Counts for the card's stat row; `null` = not loaded (render "—"). Tags are case-insensitive. */
export function libraryStats(notes: Note[] | undefined, notebookCount: number | undefined): LibraryStats {
  const tags = notes
    ? new Set(notes.flatMap((n) => parseTags(n.tags).map((t) => t.trim().toLowerCase()))).size
    : null;
  return { pages: notes ? notes.length : null, notebooks: notebookCount ?? null, tags };
}
